(function() {
  // Stock indicator
  const isB2B = document.getElementById('quick-order-app')?.dataset?.b2b === 'true';
  const inventoryThreshold = 10;
  const stockMessages = {
    'in-stock':   "In stock",
    'low-stock':  "Low stock",
    'out-of-stock': "Out of stock"
  };

  function getStockIndicatorHTML(item) {
    if (!isB2B) return '';
    if (item.product_group == 1) return '';
    if (item.inventory_management !== 'shopify') return '';
    const qty = item.inventory_quantity;
    let status;
    if (qty > 0) {
      status = qty <= inventoryThreshold ? 'low-stock' : 'in-stock';
    } else {
      status = 'out-of-stock';
    }
    return `<p class="product__inventory product__inventory--${status} font-body-bolder"><span class="product__inventory-icon"></span><span class="product__inventory-text">${stockMessages[status]}</span></p>`;
  }

  // Elements
  const searchInput     = document.getElementById('product-search');
  const searchBtn       = document.getElementById('search-btn');
  const resultsList     = document.getElementById('search-results');
  const selQtyInput     = document.getElementById('selected-qty');
  const addQoBtn        = document.getElementById('add-quick-order-btn');
  const qoItemsList     = document.getElementById('quick-order-items');
  const addToCartBtn    = document.getElementById('add-to-cart-btn');
  const addAllToListBtn = document.getElementById('add-to-list-btn');   
  const placeholderImage = 'https://sunnen-products.myshopify.com/cdn/shop/files/sunnen-placeholder-image.jpg?v=1748629215&width=1946';
  let searchDebounce;
  
  let selectedProduct = null;
  let quickOrder = JSON.parse(localStorage.getItem('quickOrder') || '[]');

  // Persist & render
  function save() {
    localStorage.setItem('quickOrder', JSON.stringify(quickOrder));
  }
 
  function renderQuickOrder() {

    qoItemsList.innerHTML = '';
    const formatterUSD = new Intl.NumberFormat('en-US', {
                          style: 'currency',
                          currency: 'USD'
                        });
    
    quickOrder.forEach((item, idx) => {
    const li = document.createElement('li');


    

    let itemPrice = "";
    const subTotal = "";

    if (item.is_sellable == "true"){
       const subTotal =  formatterUSD.format(item.price * item.qty)
       let itemPrice = formatterUSD.format(item.price);
    }


      if(item.maxError != 'undefined' && item.maxError >= 0 )
      {
            li.innerHTML = `
            <span class="qo-remove" data-idx="${idx}">X</span>
            <img src="${item.image}" width="120" alt="${item.title}" />
            <div class="qo-details">
              <span class="qo-title">${item.title}</span>
              <span class="qo-sku">SKU: ${item.sku}</span>
              ${getStockIndicatorHTML(item)}
              <span class="qo-price">${itemPrice}</span>
              <span class="qo-error">Max qty available: ${item.maxError}</span></div>
              `;
      }
      else{
      li.innerHTML = `
        <span class="qo-remove" data-idx="${idx}">X</span>
        <img src="${item.image}" width="120" alt="${item.title}" />
        <div class="qo-details">
        <span class="qo-title">${item.title}</span>
        <span class="qo-sku">SKU: ${item.sku}</span>
        ${getStockIndicatorHTML(item)}
        <span class="qo-price">${itemPrice}</span></div>
        `;
      }

      
      if(item.is_sellable == "true")
      {
        li.innerHTML += `
            <div class="number-input"><div>
              <button class="qo-decrement"> &minus;</button>
              <input type="number" class="qo-qty" data-idx="${idx}" value="${item.qty}" min="1" ${item.max ? `max="${item.max}"` : ''} ${item.locked ? 'disabled' : ''} />
              <button class="plus qo-increment"> &plus;</button>
              </div>
              <div id="error-${idx}" style="display:none"></div>
            </div>
            <span class="qo-subtotal">${subTotal}</span>
            <span><button class="btn-add-to-list"  data-idx="${idx}">Add to List</button></span>
          `;
      }
      else{
         li.innerHTML += `
            <div class="number-input" style="border:none;">
            
         Contact to purchase.
              <input type="number" class="qo-qty" data-idx="${idx}" value="${item.qty}" min="1" style="display:none"/>
            </div>
            <span class="qo-subtotal"></span>
            <span><button class="btn-add-to-list" style="display:none"></button></span>
          `;
      }
     
      qoItemsList.appendChild(li);
      const input = li.querySelector('.qo-qty');
      const subtotalEl = li.querySelector('.qo-subtotal');

      if(item.is_sellable == "true")
      {
          
        li.querySelector('.qo-decrement').addEventListener('click', () => {
          input.stepDown();
          updateRow(idx, parseInt(input.value, 10));
        });
        li.querySelector('.qo-increment').addEventListener('click', () => {
          input.stepUp();
          updateRow(idx, parseInt(input.value, 10));
        });

      }
    


      // Remove item
     
  
        if(item.is_sellable == "true")
        {
           li.querySelector('.qo-qty').addEventListener('change', e => {
            const i = +e.target.dataset.idx;
            quickOrder[i].qty = parseInt(e.target.value, 10);
            save(); 
             renderQuickOrder();
          });
          
        // Per-item “Add to List”
        li.querySelector('.btn-add-to-list').addEventListener('click', () => {
          const i = +li.querySelector('.btn-add-to-list').dataset.idx;
          const it = quickOrder[i];
          if (!defaultListId) {
            return alert('Your Swym list isn’t ready yet.');
          }
          swat.addToList(
            defaultListId,
            {
              epi:  it.variantId,
              empi: it.id,
              du:   it.url || window.location.origin + '/products/' + it.handle,
              qty:  it.qty
            },
            () => alert(`“${it.title}” added to your list!`),
            err => console.error('Swym add-to-list error:', err)
          );
        });
      }
  });


    // qty change
    qoItemsList.querySelectorAll('.qo-qty').forEach(input => {
      input.addEventListener('change', e => {
        const i = e.target.dataset.idx;
        quickOrder[i].qty = parseInt(e.target.value, 10);
        save(); 
        renderQuickOrder();
      });
    });
    
    // remove item
    qoItemsList.querySelectorAll('.qo-remove').forEach(btn => {
      btn.addEventListener('click', e => {
         const idx = parseInt(e.target.dataset.idx, 10);
        const removedSku = quickOrder[idx].sku;
        quickOrder.splice(e.target.dataset.idx, 1);
        save(); 
        renderQuickOrder();

         document.querySelectorAll(`#output-info li[data-sku="${removedSku}"]`).forEach(li => li.remove());
      });
    });

    
    const total = quickOrder.reduce(
                                      (sum, i) => sum + (i.is_sellable === true ? i.price * i.qty : 0),
                                       0
                                   );
    document.getElementById('faux-total').innerText = formatterUSD.format(total);

  // helper to update a single row
  function updateRow(idx, newQty) {
    const item = quickOrder[idx];
    item.qty = newQty < 1 ? 1 : newQty;
    save();
    // update only this row’s subtotal
    const li = qoItemsList.children[idx];
    const subEl = li.querySelector('.qo-subtotal');
    subEl.innerText = formatterUSD.format(item.price * item.qty);
    // hide any prior error
    const err = li.querySelector(`#error-${idx}`);
    if (err) err.style.display = 'none';
    
      const total = quickOrder.reduce(
                                      (sum, i) => sum + (i.is_sellable === true ? i.price * i.qty : 0),
                                       0
                                   );
                                   
    document.getElementById('faux-total').innerText = formatterUSD.format(total);
  }
}


function removeFromQuickOrder(variantId) {
  const idx = quickOrder.findIndex(item => item.variantId == variantId);
  if (idx > -1) {
    quickOrder.splice(idx, 1);
    save();       
    renderQuickOrder();
  }
}

  function doSearch() {


    const q = searchInput.value.trim();
    if (q.length < 3) {
      resultsList.innerHTML = '';
      return;
    }
    
    const productSku = searchInput.value.trim();
    const AllClear = true;
    if (!productSku) return;
    fetch(window.Shopify.routes.root +
      `search/suggest.json?q=${encodeURIComponent(productSku)}` +
      `&resources[type]=product&resources[options][unavailable_products]=hide` +
      `&resources[options][fields]=title,variants.sku,variants.title,variants.barcode,tag`
    )
      .then(r => {
        if (!r.ok) { DisplayMessage(productSku, r.message, 'Failed'); throw new Error(r.status); }
        return r.json();
      })
      .then(data => {
        const prods = data.resources.results.products || [];
        resultsList.innerHTML = '';
        if (prods.length === 0) {
          const li = document.createElement('li');
          li.textContent = 'No products found';
          li.classList.add('no-results');
          resultsList.appendChild(li);
          return;
        }
           prods.forEach(p => {
            const ProdTags = p.tags.join(",").toLowerCase();
            const tags = Array.isArray(p.tags) ? p.tags : (p.tags ? String(p.tags).split(',') : []);
            const tagsLower = tags.map(t => String(t).toLowerCase());
   
             if(ProdTags.includes("machine") == true){
               AllClear = false;
             }

             
            if(AllClear == true){

             const skuFromTag = getSkuFromTags(tags);             
             const skuLine = skuFromTag ? `SKU: ${skuFromTag}` : '';

            const imgUrl = p.image || placeholderImage;
            const li = document.createElement('li');
            li.innerHTML = `<img src="${imgUrl}" width="40" /><span>${p.title} <br> ${skuLine}</span>`;
            li.addEventListener('click', () => {
            
              resultsList.innerHTML = '';
              
              // fetch extra details…
              fetch(`/products/${p.handle}?view=quick-details`)
                .then((response) => {
                    if (!response.ok) {
                        DisplayMessage(productSku, 'Error fetching additional product details.', 'Failed');
              
                        throw new Error(response.status);
                    }
                    return response.json();
                })
               .then((details) => {
                  const variantId = details.variantID;
                  const minQty    = details.min || 1;
                  const price = details.price;
                  const sku = details.sku;
                  const max = details.max;
                  const increment = details.increment; 
                  const is_sellable = details.is_sellable;

                  // build the in‐memory selectedProduct
                  selectedProduct = {
                    id:        p.id,
                    fullData:  true,
                    handle:    p.handle,
                    title:     p.title,
                    price:     price,
                    sku:       sku,
                    min:       minQty,
                    max:       max,
                    increment: increment,
                    image:     p.image || placeholderImage,
                    variants:  [{
                      id:      variantId,
                      price:   parseFloat(price / 100)
                    }],
                    is_sellable: is_sellable,
                    inventory_management: details.inventory_management,
                    inventory_quantity:   parseInt(details.inventory_quantity, 10),
                    product_group:        details.product_group,
                    maxError: -1
                  };
             
                 searchInput.value = `${p.title} ${sku}`;
                 })
                .catch((error) => {
                  console.log("ERROR ADDING")
                  // fallback preview if quick‐details fails
                  selectedProduct = {
                    id:     p.id,
                    fullData: false
                  };
                  selQtyInput.min   = 1;
                  selQtyInput.value = 1;
                  searchInput.value =  p.title;
                });
            });
      
             resultsList.appendChild(li);
               
            }
             
           
          });
       
      });
  }


  searchInput.addEventListener('input', () => {
    clearTimeout(searchDebounce);
    searchDebounce = setTimeout(doSearch, 300);
  });

  
  searchBtn.addEventListener('click', doSearch);
  searchInput.addEventListener('keydown', e => {
    if (e.key === 'Enter') { e.preventDefault(); doSearch(); }
  });
 
  // Fill in search, populate qty.
  addQoBtn.addEventListener('click', () => {
      if (!selectedProduct) return;
    
      let qty = parseInt(selQtyInput.value, 10);
      let maxError =  -1;
    
      let min = parseInt(selectedProduct.min, 0);
    
      if (isNaN(qty) || qty < min) qty = min;
      let maxQty = parseInt(selectedProduct.max, 0)
    
      if(maxQty > 0 && qty > maxQty){
        qty = maxQty;
        maxError = maxQty;
        max    = maxQty;
        locked = true;
      }
    else{
      max = '';
      locked = false;
    }

      if(min > 0 && qty < min){
        qty = min;
      }

    const variantId = selectedProduct.variants[0].id;      
    
    const existingIdx = quickOrder.findIndex(item => item.variantId === variantId);

     if (existingIdx > -1) {
        quickOrder[existingIdx].qty += qty;
      } else {
      
        quickOrder.push({
                              variantId: selectedProduct.variants[0].id,
                              id:        selectedProduct.id,
                              title:     selectedProduct.title,
                              sku:       selectedProduct.sku,
                              image:     selectedProduct.image,
                              price:     selectedProduct.variants[0].price,
                              max:       selectedProduct.max,
                              min:       selectedProduct.min,
                              qty:       qty,
                              is_sellable: selectedProduct.is_sellable,
                              inventory_management: selectedProduct.inventory_management,
                              inventory_quantity:   selectedProduct.inventory_quantity,
                              product_group:        selectedProduct.product_group,
                              maxError: maxError,
                              max:      max,
                              locked : locked
                              });
          }
      save();
      renderQuickOrder();
      
      searchInput.value = '';
      selQtyInput.value = 1;
      selectedProduct= null;

 
  });

addToCartBtn.addEventListener('click', async () => {

  let addedAny = false;

  for (const item of quickOrder.slice()) {

    const is_sellable = item.is_sellable
    if(is_sellable == "true")
    {
      const sku = item.sku;
      const qty = item.qty;
      const formData = {
        items: [{ id: item.variantId, quantity: qty }]
      };

      try {
          const resp = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        });
        
        const json = await resp.json();
        if (!json.items) {
        let errMsg = json.message || 'Unknown error';
        if (errMsg.includes("You can't add more")) {
          errMsg = "All available products have been added to cart.";
        }
        DisplayMessage(sku, errMsg, ''); //JUST DISPLAY ERRORS
            const maxMatch = errMsg.match(/maximum.*?(\d+)/i);
            if (maxMatch) {
              const maxQty = parseInt(maxMatch[1], 10);
          
              // find & update the item in quickOrder
              const idx = quickOrder.findIndex(i => i.variantId == item.variantId);
              if (idx > -1) {
                quickOrder[idx].qty = maxQty;
                quickOrder[idx].maxError   = maxQty;
                quickOrder[idx].max    = maxQty;
                quickOrder[idx].locked = true;
                save();
              }
            }
        } else {
          addedAny = true;
          removeFromQuickOrder(item.variantId);
        }
      } catch (err) {
        DisplayMessage(sku, err.message, ''); 
        
      }
    }
    else{
        const sku = item.sku;
        DisplayMessage(sku, " ", 'Please contact Sunnen to purchase.'); 
      }
  
    await new Promise(resolve => setTimeout(resolve, 300));
  }

  refreshCartCount();
  renderQuickOrder();
  if (addedAny) {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { open: true }
    }));
    armOneTimeCloseOnClick();
  }


});

  // Initial render
  renderQuickOrder();



function DisplayMessage(sku, MessageText, status) {
  document.getElementById('output-info').style.display = "block";
  const outputDiv = document.getElementById('output-info');
  const li = document.createElement('li');
  li.className = `output-info-${status}`;    
  li.dataset.sku = sku;
  const trimmedMessage = (MessageText || '').trim();
  const suffix = trimmedMessage ? `, ${trimmedMessage}` : '';
  li.textContent = `${status} ${sku}${suffix}`;
  outputDiv.appendChild(li);
}

function getSkuFromTags(tags) {
  if (!tags) return '';
  const arr = Array.isArray(tags) ? tags : String(tags).split(',');
  for (const raw of arr) {
    const t = String(raw).trim();
    const m = /^sku\s*:\s*(.+)$/i.exec(t); // matches 'SKU: xxx' or 'sku :xxx'
    if (m) return m[1].trim();
  }
  return '';
}

  // ─── SWYM INTEGRATION ─────────────────────────────────────────────────────
  let defaultListId = null;

  // Utility to batch into chunks of 10
  function chunkArray(arr, size) {
    const out = [];
    for (let i = 0; i < arr.length; i += size) {
      out.push(arr.slice(i, i + size));
    }
    return out;
  }

  // 1) Initialize on SDK load
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function(swatInstance) {
    window.swat = swatInstance; // make it globally available for our handlers

    swat.fetchLists({
      callbackFn: lists => {
        if (lists.length) {
          defaultListId = lists[0].lid;
        } else {
          swat.createList(
            { lname: "Quick Order" },
            newList => defaultListId = newList.lid,
            err     => console.error("Create list failed:", err)
          );
        }
      },
      errorFn: err => console.error("Fetch lists failed:", err)
    });
  });


  addAllToListBtn.addEventListener('click', () => {
    if (!defaultListId) return alert("List not ready yet.");
    if (!quickOrder.length) return alert("Your cart is empty.");

    // Map to Swym shape
    const products = quickOrder.map(item => ({
      epi:  item.variantId,
      empi: item.id,
      du:   item.url || window.location.origin + '/products/' + item.handle,
      qty:  item.qty
    }));

    // Send in batches of 10
    chunkArray(products, 10).forEach(batch => {
      swat.addProductsToList(
        defaultListId,
        batch,
        () => console.log("Batch added"),
        err => console.error("Batch add error:", err)
      );
    });

    alert("All items pushed to your list!");
  });


function refreshCartCount() {
  fetch('/cart.js')
    .then(res => {
      if (!res.ok) throw new Error('Cart fetch failed');
      return res.json();
    })
    .then(cart => {
      document.querySelectorAll('cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.setAttribute('aria-label', `${cart.item_count} items`);
        el.removeAttribute('hidden');
      });
    })
    .catch(err => console.error('Unable to refresh cart count:', err));
}

function closeCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  if (drawer.tagName.toLowerCase() === 'details') drawer.open = false;
  else drawer.removeAttribute('open');

  if (typeof drawer.close === 'function') { try { drawer.close(); } catch(_) {} }
  document.dispatchEvent(new CustomEvent('cart-drawer:closed'));
}


function armOneTimeCloseOnClick() {
  const controller = new AbortController();
  const { signal } = controller;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.drawer__close-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    closeCartDrawer();
    controller.abort();
  }, { signal });
}

document.addEventListener('click', (e) => {
  if (
    !resultsList.contains(e.target) &&
    !searchInput.contains(e.target) &&
    !searchBtn.contains(e.target)
  ) {
    resultsList.innerHTML = '';  
  }
});
  
})();


